// Checkpoint semantics shared by the desk, Checkpoints, History and the mobile card.
// Written against docs/review-fixes-contracts.md; every new field is optional so older backends still work.

/** Run 6 makes no trading decision. Older backends don't send `scoring_only`, so run 6 is scoring-only by rule. */
export const isScoringOnly = (cp) => !!cp && (cp.scoring_only === true || (cp.scoring_only == null && cp.run === 6));

/** Tagged LATE by the enqueue guard (contract item 3). */
export const isLate = (cp) => !!cp?.late;

/** Original (non-RECALC) checkpoints that carry a trading decision, oldest run first. */
export const decisionRuns = (checkpoints = []) =>
  checkpoints.filter((c) => !c.recalc_of && !isScoringOnly(c)).sort((a, b) => a.run - b.run);

/** The current decision: the latest original checkpoint that is not scoring-only. */
export const currentDecision = (checkpoints = []) => {
  const runs = decisionRuns(checkpoints);
  return runs[runs.length - 1] || null;
};

/** The post-close review checkpoint (Run 6), if recorded. */
export const postCloseReview = (checkpoints = []) => checkpoints.find((c) => !c.recalc_of && isScoringOnly(c)) || null;

/** An IV skew reading safe to display: present, with points, and not flagged suspect. */
export const skewUsable = (skew) => !!skew && !skew.suspect;

/** P(up)/P(down) are shown only when modelled. `p_close_modeled === false` means they are the fixed 0.5. */
export const pCloseModeled = (cp) => cp?.p_close_modeled !== false;

/** "late by 4 min 10 s" */
export function lateLabel(cp) {
  const s = cp?.late_by_s;
  if (s == null) return "Late run";
  const m = Math.floor(s / 60), r = Math.round(s % 60);
  return `Late by ${m ? `${m} min ` : ""}${r} s`;
}

/** Minimum sample for a headline rate or expectancy (item 16). */
export const MIN_N = 30;
